import Typography from '@mui/material/Typography';
import { type Column as TableColumn } from 'further-ui/components/Table';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { numberToCurrencyString } from 'further-ui/utils';
import { ActionRefLabels } from 'further-ui/labels/action';
import { Transaction } from './types';

type Props = {
  baseCurrency: CurrencyCode;
};

const getColumns = ({
  baseCurrency,
}: Props): Array<TableColumn<Transaction>> => [
  {
    key: 'transactionDate',
    label: 'Date',
    textOverflowEllipsis: true,
    width: 115,
    render: ({ transactionDate }) => transactionDate.toReadable(),
  },
  {
    key: 'actionRef',
    label: 'Action',
    textOverflowEllipsis: true,
    width: 175,
    render: ({ actionRef }) => ActionRefLabels[actionRef],
  },
  {
    key: 'transactionCurrency',
    label: 'Currency (TCY)',
    textOverflowEllipsis: true,
    width: 115,
  },
  {
    key: 'transactionType',
    label: 'Transaction type',
    textOverflowEllipsis: true,
    width: 175,
  },
  {
    key: 'description',
    label: 'Description',
    textOverflowEllipsis: true,
    width: 175,
    render: ({ description }) =>
      description || <Typography color="grey.500">--</Typography>,
  },
  {
    key: 'amountIncVatLcy',
    label: 'Amount (LCY)',
    textOverflowEllipsis: true,
    width: 175,
    render: ({ amountIncVatLcy }) =>
      numberToCurrencyString(amountIncVatLcy, {
        currency: baseCurrency,
        negativeInBrackets: true,
      }),
  },
  {
    key: 'amountIncVatTcy',
    label: 'Amount (TCY)',
    textOverflowEllipsis: true,
    width: 175,
    render: ({ amountIncVatTcy, transactionCurrency }) =>
      numberToCurrencyString(amountIncVatTcy, {
        currency: transactionCurrency,
        negativeInBrackets: true,
      }),
  },
  {
    key: 'counterpartyLabel',
    label: 'Counterparty',
    textOverflowEllipsis: true,
    width: 175,
  },
  {
    key: 'bankAccountLabel',
    label: 'Bank account',
    textOverflowEllipsis: true,
    width: 175,
    render: ({ bankAccountLabel }) =>
      bankAccountLabel || <Typography color="grey.500">--</Typography>,
  },
];

export default getColumns;
